import { IDefaultAssembly } from 'src/interfaces';

export const getLocationGroupCountText = (
  defaultAssemblies: IDefaultAssembly[] = [],
  assemblyId?: number,
) => {
  const now = new Date();
  const filteredLocGrpAssemblies = defaultAssemblies.filter(
    (locGroupAssembly) =>
      locGroupAssembly.assembly_id === assemblyId &&
      (!locGroupAssembly.valid_to || new Date(locGroupAssembly.valid_to) > now),
  );

  const uniqueLocationGroupIds = new Set(
    filteredLocGrpAssemblies.map((assembly) => assembly.location_group_id),
  );

  const count = uniqueLocationGroupIds.size;

  const locationGroupCountText =
    count === 0
      ? '0 location group'
      : `${count} location group${count !== 1 ? 's' : ''}`;

  return locationGroupCountText;
};
